import React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';
import { useTranslation } from '../utils/translations';

const Footer = ({ language }) => {
  const t = useTranslation(language);
  
  return (
    <AppBar 
      position="fixed" 
      color="primary"
      elevation={0}
      sx={{ 
        top: 'auto', 
        bottom: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ justifyContent: 'flex-end', minHeight: '48px !important' }}>
        <Typography 
          variant="body2" 
          color="inherit"
          sx={{ 
            fontSize: '0.875rem',
            fontWeight: 400,
          }}
        >
          {t('copyright')}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Footer; 